import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DropdownModule} from 'primeng/dropdown';
import {FormsModule} from '@angular/forms';
import {SettingsComponent} from './settings.component';
import {AutoCompleteModule, CalendarModule, CheckboxModule, GrowlModule} from 'primeng/primeng';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {ProgressBarModule} from 'primeng/progressbar';
import {CoreModule} from '../../core/core.module';
import {TableModule} from 'primeng/table';
import {TranslateModule} from '@ngx-translate/core';
import {RadioButtonModule} from "primeng/primeng";

@NgModule({
  imports: [
    CommonModule,
    DropdownModule,
    FormsModule,
    CalendarModule,
    CheckboxModule,
    AutoCompleteModule,
    NgbModule,
    GrowlModule,
    ProgressBarModule,
    CoreModule,
    TableModule,
    RadioButtonModule,
    TranslateModule
    // TaxReportRoutingModule
  ],
  declarations: [SettingsComponent]
})
export class SettingsModule {
}



// WEBPACK FOOTER //
// /opt/app/src/app/features/settings/settings.module.ts